import SupplierInput from "@/widgets/Inputs/SupplierInput.vue";

export default {
	data() {
		return {
			filterSupplier: {
				name: "",
				_id: ""
			}
		};
	},
	watch: {
		"filterSupplier._id": {
			handler(val) {
				let fieldName = "supplier";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		}
	},
	components: {
		SupplierInput
	}
};
